import { render, staticRenderFns } from "./SyncConfig.vue?vue&type=template&id=3f7384a3"
import script from "./SyncConfig.vue?vue&type=script&lang=js"
export * from "./SyncConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports